import ImgSliderShop from './ImgSliderShop';
import { DataShop } from '../components/DataShop/DataShop';

function SliderF() {
  return <ImgSliderShop slides={DataShop} />;
}

export default SliderF;